export default {
    workOrder_comments_createSuccessMessages: "Comentario guardado",
    workOrder_comments_deleteSuccessMessages: "Comentario eliminado",
    workOrder_comments_send: "Guardar",
    workOrder_comments_placeholder: "Añadir un comentario...",
    workOrder_comments_errorUpdateComment: "No es posible editar o borrar este comentario",
    workOrder_comments_createBy: "Creado Por",
    workOrder_comments_createOn: "Fecha de Creación",
    workOrder_comments_comment: "Comentario",
};